import { render, staticRenderFns } from "./DrivewealthAccountLiquidationPage.vue?vue&type=template&id=7e402b5e&scoped=true"
import script from "./DrivewealthAccountLiquidationPage.vue?vue&type=script&lang=ts"
export * from "./DrivewealthAccountLiquidationPage.vue?vue&type=script&lang=ts"
import style0 from "./DrivewealthAccountLiquidationPage.vue?vue&type=style&index=0&id=7e402b5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e402b5e",
  null
  
)

export default component.exports